module.exports = __webpack_public_path__ + "static/media/house-damage.c2d9cbbe.svg";